import React from 'react';

const CustomModal = ({ isOpen, closeModal, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">
      <div className="fixed top-0 left-0 w-full h-full bg-white p-4 overflow-y-auto">
        <div className="relative w-full h-full mx-auto flex flex-col justify-between max-w-screen-lg">
          <button
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            onClick={closeModal}
          >
            &times;
          </button>
          <div className="p-4">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
